import type {
  StaticDataChartWidgetData,
  FileChartWidgetData,
  ForwardChartWidgetData,
  SeasonalChartWidgetData,
  SpotChartWidgetData,
  TableWidgetData
} from '@/features/_shared/widget-registry';
import { WIDGET_TYPES, widgetRegistry } from '@/features/_shared/widget-registry';

import { ChartPreviewWidget } from './ChartPreviewWidget';
import { FileChartWidget } from './FileChartWidget';
import { MarketPreviewWidget } from './MarketPreviewWidget';
import { StaticDataChartPreviewWidget } from './StaticDataChartPreviewWidget';

widgetRegistry.register<{ data: TableWidgetData }>(WIDGET_TYPES.TABLE, ({ data }) => (
  <MarketPreviewWidget data={data} />
));

widgetRegistry.register<{ data: SpotChartWidgetData }>(WIDGET_TYPES.SPOT_CHART, ({ data }) => (
  <ChartPreviewWidget
    chartType='spot'
    data={data}
  />
));

widgetRegistry.register<{ data: SeasonalChartWidgetData }>(
  WIDGET_TYPES.SEASONAL_CHART,
  ({ data }) => (
    <ChartPreviewWidget
      chartType='seasonal'
      data={data}
    />
  )
);

widgetRegistry.register<{ data: ForwardChartWidgetData }>(
  WIDGET_TYPES.FORWARD_CHART,
  ({ data }) => (
    <ChartPreviewWidget
      chartType='forward'
      data={data}
    />
  )
);

widgetRegistry.register<{ data: FileChartWidgetData }>(WIDGET_TYPES.FILE_CHART, ({ data }) => (
  <FileChartWidget data={data} />
));

widgetRegistry.register<{ data: StaticDataChartWidgetData }>(
  WIDGET_TYPES.STATIC_CHART,
  ({ data }) => <StaticDataChartPreviewWidget data={data} />
);
